import { render, staticRenderFns } from "./OnboardingIndex.vue?vue&type=template&id=2e669031&scoped=true"
import script from "./OnboardingIndex.vue?vue&type=script&lang=ts"
export * from "./OnboardingIndex.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingIndex.vue?vue&type=style&index=0&id=2e669031&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e669031",
  null
  
)

export default component.exports